import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint, LoadableLazy } from '@confluence/loadable';
import type { GlobalFeedbackCollectorComponentProps } from './GlobalFeedbackCollector.ts';

export const GlobalFeedbackCollector: LoadableType<
	Omit<GlobalFeedbackCollectorComponentProps, 'flags'>
> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalFeedbackCollector" */ '../src/GlobalFeedbackCollector.tsx'
			)
		).GlobalFeedbackCollector,
});

export const LazyGlobalFeedbackCollector: LoadableType<
	Omit<GlobalFeedbackCollectorComponentProps, 'flags'>
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalFeedbackCollector" */ '../src/GlobalFeedbackCollector.tsx'
			)
		).GlobalFeedbackCollector,
});

export type { GlobalFeedbackCollectorComponentProps } from '../src/GlobalFeedbackCollector.tsx';
